import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { orderEventIdZodSchema } from "@@/shared/orders/order-events/events/_order-event-id";
import { orderIdZodSchema } from "@@/shared/orders/order-id";
import { priceZodSchema } from "@@/shared/prices/price";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { systemUserZodSchema } from "@@/shared/users/system-user";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
import { orderChangeIdZodSchema } from "./_order-change-id";

const orderChangeSchemaFactory = <
    const ChangeType extends Uppercase<string>,
    OrderChangePayload,
>(
    type: ChangeType,
    payloadSchema: z.ZodType<OrderChangePayload & { type: ChangeType }>,
) => {
    // const dataSchema = payloadSchema.and(z.object({ type: z.literal(type) }));
    return z.object({
        _id: orderChangeIdZodSchema,
        _type: z.literal("ORDER_CHANGE"),
        _createdAt: isoAndUnixZodSchema,
        _changedBy: userIdZodSchema.or(systemUserZodSchema),
        /** Price is the price of the change, could be negative or positive */
        price: priceZodSchema,
        type: z.literal(type),
        changeFor: z.object({
            orderEventIds: orderEventIdZodSchema.array(),
            orderGroupId: orderGroupIdZodSchema,
            orderId: orderIdZodSchema,
            providerId: providerIdZodSchema,
        }),
        data: payloadSchema,
    });
};

export { orderChangeSchemaFactory };
